import { FormattedMessage } from 'react-intl';
import { LeadStatus } from 'types/leads';
import { Dictionary } from 'utils/constants/dictionary';
import './LeadStatusButton.scss';

type Props = {
	status: LeadStatus;
	highlighted?: boolean;
	onSelect: (value: LeadStatus) => void;
};

const getStatusCn = (status: LeadStatus): string => {
	switch (status) {
		case LeadStatus.CONTACTED: return 'lead-status-btn_contacted';
		case LeadStatus.IN_NEGOTIATIONS: return 'lead-status-btn_in-negotiations';
		case LeadStatus.LINK_SENT: return 'lead-status-btn_sent';
		case LeadStatus.LOST: return 'lead-status-btn_lost';
		case LeadStatus.NEW_LEAD: return 'lead-status-btn_new-lead';
		case LeadStatus.POSTPONED: return 'lead-status-btn_postponed';
		case LeadStatus.SOLD: return 'lead-status-btn_sold';
		default: return '';
	}
};

const getMessageData = (status: LeadStatus): {
	defaultMessage: string;
	id: string;
} => {
	switch (status) {
		case LeadStatus.CONTACTED:
			return { defaultMessage: status, id: Dictionary.leads.status.contacted };
		case LeadStatus.IN_NEGOTIATIONS:
			return { defaultMessage: status, id: Dictionary.leads.status.inNegotiations };
		case LeadStatus.LINK_SENT:
			return { defaultMessage: status, id: Dictionary.leads.status.linkSent };
		case LeadStatus.LOST:
			return { defaultMessage: status, id: Dictionary.leads.status.lost };
		case LeadStatus.NEW_LEAD:
			return { defaultMessage: status, id: Dictionary.leads.status.newLead };
		case LeadStatus.POSTPONED:
			return { defaultMessage: status, id: Dictionary.leads.status.postponed };
		case LeadStatus.SOLD:
			return { defaultMessage: status, id: Dictionary.leads.status.sold };
		default:
			return { defaultMessage: 'Default status', id: 'default-id' };
	}
};

const LeadStatusButton = ({ status, highlighted = false, onSelect }: Props): JSX.Element => (
	<div className={`lead-status-btn-wrap ${highlighted ? 'lead-status-btn-wrap_highlighted' : ''}`}>
		<div className={`lead-status-btn ${getStatusCn(status)}`} onClick={() => onSelect(status)}>
			<FormattedMessage {...getMessageData(status)} />
		</div>
	</div>
);

export default LeadStatusButton;
